<template>
    <select class="form-control dropdown-bigger" v-bind:value="value" v-on:input="$emit('input', $event.target.value)">
        <option selected>Choose brand</option>
        <option :key="type.id" :value="type.id" v-for="type in types">{{type.name}}</option>
    </select>
</template>
<script>
    export default {
        data() {
            return {
                types: []
            }
        },
        props: ['value'],
        async mounted() {
            this.types = await this.$store.dispatch('DROPDOWN_BRANDS')
            this.$parent.brandsLoaded = true
        },
    }
</script>
<style>
    .dropdown-bigger{
        padding: .75rem;
    }
</style>
